import React from 'react';
import { effectDef } from './content';

export function CardTypeLabel({ id }: { id: string }) {
    const kind = id.startsWith('U') ? 'Recruit' : effectDef(id).kind;
    const [label, path] = kind === 'Recruit' ? ['RECRUIT', 'M7 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6M2 15v-2a5 5 0 0 1 10 0v2M14 5v6M11 8h6']
        : kind.startsWith('Kept') ? ['KEPT', 'M3 2h10v14H3zM6 2v7l2-2 2 2V2']
        : kind === 'Run passive' ? ['PASSIVE', 'M8 8C3-1-2 15 5 12l6-8c7-3 7 13 2 6L8 8']
        : kind === 'Token' ? ['TOKEN', 'M2 5h10v11H2zM5 2h10v11M5 8h4M7 6v4']
        : ['NOW', 'M10 1 3 9h5l-2 8 8-10H9z'];
    return <span className="card-type-label"><svg viewBox="0 0 18 18" aria-hidden="true"><path d={path} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>{label}</span>;
}
